<template>
  <div>
    <topbar/>

    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="row my-3 ml-auto">
            <div class="col-9">
              <h1>
                <span>Projects</span>
                <button type="button" class="btn btn-primary ml-2" data-toggle="modal" data-target="#filter-projects" @click="openFilterProjects">Filter</button>
              </h1>
            </div>
            <div class="mt-2">
              <router-link to="/project/new" class="mr-4">
                <button type="button" class="btn btn-success">Create project</button>
              </router-link>
              <button v-if="isAdmin" type="button" class="btn btn-primary" @click="$refs.importProject.show()">Import project</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">

        <b-table
          class="table table-hover" data-sortable="true"
          show-empty
          stacked="md"
          id="projects-table"
          :items="projects.items"
          :fields="fields"
        >

          <template slot="name" slot-scope="row">
            <router-link :to="'/project/' + row.item.id">{{ row.value }}</router-link>
          </template>
          <template slot="phases" slot-scope="row">
            <span v-if="$getCurrentPhase(row.value)" class="badge" :class="'badge-' + $getPhaseColorByName($getCurrentPhase(row.value).phase.name)">
              {{ $getCurrentPhase(row.value).phase.name }}
            </span>
          </template>
          <template slot="owner" slot-scope="row">
            {{ row.value.username }}
          </template>
          <template slot="portfolio_manager" slot-scope="row">
            {{ row.value.length > 0 ? row.value[0].username : '' }}
          </template>
          <template slot="last_update_date" slot-scope="row">
            {{ row.value }}
          </template>
          <template v-if="isAdmin" slot="id" slot-scope="row">
            <a :href="$serverAddr + '/data?project_ids[]=' + row.value + '&type=json'">
              <span class="badge badge-primary">json</span>
            </a>
            <a :href="$serverAddr + '/data?project_ids[]=' + row.value + '&type=csv'" class="ml-2">
              <span class="badge badge-primary">csv</span>
            </a>
          </template>

        </b-table>
      </div>
      <div class="row my-5 fixed-bottom justify-content-center">
        <b-pagination
          v-model="currentPage"
          @input="loadProjects"
          :total-rows="projects.pagination.total"
          :per-page="perPage"
          aria-controls="projects-table"
        ></b-pagination>
      </div>
    </div>

    <b-modal ref="filterProjects" id="filter-projects" size="lg">

      <template slot="modal-header">
      </template>

      <template slot="default" >
        <form>
          <div class="row control-group">
            <div class="col-3">
              <h5>Filter projects</h5>
              <h6>Project phase</h6>
              <div class="form-check mt-2" v-for="phase in phases" :key="phase.id">
                <label class="form-check-label">
                  <input type="checkbox" @change="filterPhaseChanged($event, phase.id)" class="form-check-input" value="">
                  <span class="badge badge-success" :class="'badge-' + phase.color">{{phase.name}}</span>
                </label>
              </div>
            </div>
            <div class="col-9">
              <b-form-select multiple placeholder="Username" v-model="searchUsers" :options="users" value-field="id" text-field="username"></b-form-select>
            </div>

          </div>
        </form>
      </template>

      <template slot="modal-footer">
        <input class="btn btn-lg btn-success btn-block" @click="filterProjects" type="submit" value="Filter"/>
      </template>
    </b-modal>

    <b-modal ref="importProject" id="import-project" size="lg"  hide-footer>

      <template slot="modal-header">
        <h5>Import project</h5>
      </template>

      <template slot="default" >
        <form target="_blank" :action="$serverAddr + '/data'" method="post" enctype="multipart/form-data" @click="refresh">
          Select a file: <input type="file" name="file" id="fileToUpload"><br><br>
          <input type="submit">
        </form>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Topbar from '../components/Topbar'
export default {
  name: 'Projects',
  components: { Topbar },
  mounted () {
    this.loadProjects()
  },
  computed: {
    isAdmin () {
      return this.$store.getters.user.role === 'Admin'
    },
    projects () {
      return this.$store.getters.projects
    },
    phasesIds () {
      return this.$store.getters.getAllPhasesIds
    },
    phases () {
      return this.$store.getters.phases
    },
    totalRows () {
      return this.projects.total ? this.projects.total : 0
    },
    users () {
      return this.$store.getters.users
    }
  },
  methods: {
    loadProjects () {
      this.$store.dispatch('loadProjects', {
        phases: this.phasesIds,
        name: '',
        page: this.currentPage,
        perPage: this.perPage,
        sortBy: 'id',
        desc: 'ASC',
        users: '',
        start_dates: '',
        end_dates: ''
      })
    },
    filterPhaseChanged (e, phaseId) {
      let val = e.target.checked
      if (val) {
        this.selectedPhases.push(phaseId)
      } else {
        this.selectedPhases.splice(this.selectedPhases.indexOf(phaseId), 1)
      }
    },
    filterProjects () {
      this.$store.dispatch('loadProjects', {
        phases: this.selectedPhases,
        name: this.searchName,
        page: this.currentPage,
        perPage: this.perPage,
        sortBy: 'id',
        desc: 'ASC',
        users: this.searchUsers,
        start_dates: '',
        end_dates: ''
      })
      this.$refs.filterProjects.hide()
    },
    openFilterProjects () {
      this.$refs.filterProjects.show()
    },
    refresh () {
      setTimeout(() => this.loadProjects(), 1000)
    }
  },
  data () {
    return {
      currentPage: 1,
      perPage: 5,
      selectedPhases: [],
      searchUsers: [],
      fields: [
        { key: 'name', label: 'Project name' },
        { key: 'phases', label: 'Actual phase' },
        { key: 'owner', label: 'Owner' },
        { key: 'portfolio_manager', label: 'Portfolio manager' },
        { key: 'last_update_date', label: 'Last update' },
        { key: 'id', label: 'Export' }
      ]
    }
  }
}
</script>
